export const formatter = (unit = '', precision = 1, factor = 1) => (number: number) =>
    `${new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
    }).format(number / factor)}${unit == '' ? '' : ' '}${unit}`;
